import React, { ComponentType } from "react";
import { Tooltip } from "antd";

interface WithTooltipProps {
  text: string;
  limit?: number;
  textClassName?: string;
  isOnHover?: boolean;
}

const withTooltip = <P extends object>(
  WrappedComponent: ComponentType<P & WithTooltipProps>
) => {
  return ({
    text,
    limit = 20,
    isOnHover = false,
    ...props
  }: P & WithTooltipProps) => {
    if (!text) return null;

    const shouldTruncate = text.length > limit;
    const truncatedText = shouldTruncate ? text.slice(0, limit) + "..." : text;

    return shouldTruncate ? (
      <Tooltip title={text} trigger={isOnHover ? "hover" : ["click", "hover"]}>
        <span style={{ cursor: "pointer" }} className={props.textClassName}>
          <WrappedComponent {...(props as P)} text={truncatedText} />
        </span>
      </Tooltip>
    ) : (
      <div className={props.textClassName}>
        <WrappedComponent {...(props as P)} text={text} />
      </div>
    );
  };
};

export default withTooltip;

interface TextComponentProps {
  text: string;
}
const TextComponent: React.FC<TextComponentProps> = ({
  text,
  className,
}: {
  text: React.ReactNode;
  className?: string;
}) => <span className={className}>{text}</span>;

export const TextWithTooltip = withTooltip(TextComponent);
